import { t } from '@/i18n';

import {
  buildCreateMutationErrorOverride,
  buildDeleteMutationErrorOverride,
  buildSaveMutationErrorOverride,
} from './shared';

/**
 * Functions, not constants. A module-level string would resolve once at import and pin the
 * wording to whatever language the app booted in; calling through resolves it when the error is
 * actually shown. Renamed from the former UPPER_SNAKE constants in !1545 — same wording, same call sites, one extra `()`.
 */
export const getCreativeGroupDuplicateMessage = (): string =>
  t('modules.campaigns.mutationErrors.creativeGroup.duplicate');
export const getCreativeGroupUnavailableMessage = (): string =>
  t('modules.campaigns.mutationErrors.creativeGroup.unavailable');
export const getCreativeGroupExpectationFailedMessage = (): string =>
  t('modules.campaigns.mutationErrors.creativeGroup.expectationFailed');
export const getCreativeGroupCreateGenericErrorMessage = (): string =>
  t('modules.campaigns.mutationErrors.creativeGroup.createGeneric');
export const getCreativeGroupSaveImmutableMessage = (): string =>
  t('modules.campaigns.mutationErrors.creativeGroup.saveImmutable');
export const getCreativeGroupSaveGenericErrorMessage = (): string =>
  t('modules.campaigns.mutationErrors.creativeGroup.saveGeneric');
export const getCreativeGroupDeleteInUseMessage = (): string =>
  t('modules.campaigns.mutationErrors.creativeGroup.deleteInUse');
export const getCreativeGroupAlreadyDeletedMessage = (): string =>
  t('modules.campaigns.mutationErrors.creativeGroup.alreadyDeleted');
export const getCreativeGroupDeleteGenericErrorMessage = (): string =>
  t('modules.campaigns.mutationErrors.creativeGroup.deleteGeneric');

// Built per call, not at import: the builders copy their spec eagerly, so a resolver made at
// module load would freeze the wording to the boot language. Same builder, same spec, same
// result — only the moment of construction moves.
export const getCreativeGroupCreateMutationErrorOverride = (
  ...args: Parameters<ReturnType<typeof buildCreateMutationErrorOverride>>
) =>
  buildCreateMutationErrorOverride({
    duplicateMessage: getCreativeGroupDuplicateMessage(),
    notFoundMessage: getCreativeGroupUnavailableMessage(),
    expectationFailedMessage: getCreativeGroupExpectationFailedMessage(),
  })(...args);

// Built per call, not at import: the builders copy their spec eagerly, so a resolver made at
// module load would freeze the wording to the boot language. Same builder, same spec, same
// result — only the moment of construction moves.
export const getCreativeGroupSaveMutationErrorOverride = (
  ...args: Parameters<ReturnType<typeof buildSaveMutationErrorOverride>>
) =>
  buildSaveMutationErrorOverride({
    duplicateMessage: getCreativeGroupDuplicateMessage(),
    notFoundMessage: getCreativeGroupUnavailableMessage(),
    expectationFailedMessage: getCreativeGroupExpectationFailedMessage(),
    immutableMessage: getCreativeGroupSaveImmutableMessage(),
  })(...args);

// Built per call, not at import: the builders copy their spec eagerly, so a resolver made at
// module load would freeze the wording to the boot language. Same builder, same spec, same
// result — only the moment of construction moves.
export const getCreativeGroupDeleteMutationErrorOverride = (
  ...args: Parameters<ReturnType<typeof buildDeleteMutationErrorOverride>>
) =>
  buildDeleteMutationErrorOverride({
    inUseMessage: getCreativeGroupDeleteInUseMessage(),
    notFoundMessage: getCreativeGroupAlreadyDeletedMessage(),
  })(...args);
